import request from '@/utils/request'

const { uc, portal, bpmRunTime, bpmModel } = window.context

// 保存常用语
export function savaCommonWords(data) {
  const url = `${bpmModel}/flow/approvalItem/v1/save`
  return request.post(url, data)
}

// 获取常用语
export function getCommonWords(data) {
  const url = `${bpmModel}/flow/approvalItem/v1/listJson?isPersonal=true`
  return request.post(url, data)
}

// 删除常用语
export function delCommonWords(ids) {
  const url = `${bpmModel}/flow/approvalItem/v1/remove?ids=${ids}`
  return request.delete(url)
}

// 编辑委托
export function agentSave(data) {
  const url = `${bpmModel}/flow/agent/v1/save`
  return request.post(url, data)
}

// 获取委托列表
export function getAgentList(isAdmin, data) {
  const url = `${bpmModel}/flow/agent/v1/listJson?isMgr=${isAdmin}`
  return request.post(url, data)
}

// 查看委托详情
export function getAgentDetail(id) {
  const url = `${bpmModel}/flow/agent/v1/agentGet?id=${id}`
  return request.get(url)
}

// 删除委托
export function delAgentList(ids) {
  const url = `${bpmModel}/flow/agent/v1/remove?ids=${ids}`
  return request.delete(url)
}

// 获取流程列表
export function getFlowList(data) {
  const url = `${bpmModel}/flow/def/v1/listJson`
  return request.post(url, data)
}

// 获取委托流程
export function getFlowWithOutAuth(data) {
  data.querys = data.querys || []
  data.querys.push({
    property: 'IS_MAIN_',
    value: 'Y',
    operation: 'EQUAL',
    group: 'main',
    relation: 'AND',
  })
  const url = `${bpmModel}/flow/def/v1/query`
  return request.post(url, data)
}

// 获取领导秘书列表
export function getSecretarylist(data) {
  const url = `${bpmRunTime}/runtime/bpmSecretaryManage/v1/list?personal=true`
  return request.post(url, data)
}

// 删除领导秘书
export function delSecretary(ids) {
  const url = `${bpmRunTime}/runtime/bpmSecretaryManage/v1/removes?ids=${ids}`
  return request.delete(url)
}

// 保存领导秘书
export function saveSecretary(data) {
  const url = `${bpmRunTime}/runtime/bpmSecretaryManage/v1/save`
  return request.post(url, data)
}

// 保存领导秘书
export function getSecretaryDetail(userId) {
  const url = `${bpmRunTime}/runtime/bpmSecretaryManage/v1/get/${userId}`
  return request.get(url)
}

// 获取常用联系人
export function getTopContacts(queryFilter) {
  const url = `${uc}/uc/ucGroup/v1/query`
  return request.post(url, queryFilter)
}

//保存常用联系人
export function saveTopContacts(model) {
  const url = `${uc}/uc/ucGroup/v1/save`
  return request.post(url, model)
}

//删除常用联系人
export function removeTopContactsBatch(ids) {
  const url = `${uc}/uc/ucGroup/v1/remove?ids=${ids}`
  return request.delete(url)
}

//获取常用联系人分组的用户
export function getUcGroupUser(groupId, queryFilter) {
  const url = `${uc}/uc/ucGroupUser/v1/getGroupUsers?groupId=${groupId}`
  return request.post(url, queryFilter)
}

//删除常用联系人列表用户
export function removeUcGroupUser(ids) {
  const url = `${uc}/uc/ucGroupUser/v1/remove?ids=${ids}`
  return request.delete(url)
}

//保存常用联系人列表用户
export function saveUserGroup(param) {
  const url = `${uc}/uc/ucGroupUser/v1/saveJson`
  return request.post(url, param)
}

/**
 * date: 2021/09/26
 * @description 邮箱接口
 *
 */
// 获取邮箱列表
export function getMailTreeList() {
  const url = `${portal}/mail/mail/mail/v1/getMailTreeData`
  return request.get(url)
}

// 保存外部邮箱配置
export function saveMailSetting(data) {
  const url = `${portal}/mail/mail/mailSetting/v1/save?isOriginPwd=${data.isOriginPwd}`
  return request.post(url, data)
}

// 测试邮箱连接(编辑/新增情况)
export function testMailConnect(data) {
  const url = `${portal}/mail/mail/mailSetting/v1/test?isOriginPwd=${data.isOriginPwd}`
  return request.post(url, data)
}

// 测试邮箱连接(根据id)
export function testMailConnectById(id) {
  const url = `${portal}/mail/mail/mailSetting/v1/test?id=${id}`
  return request.post(url)
}

// 获取外部邮箱配置列表
export function getMailSettingList(queryFilter) {
  const url = `${portal}/mail/mail/mailSetting/v1/listJson`
  return request.post(url, queryFilter)
}

// 同步邮件
export function getSysncById(id) {
  const url = `${portal}/mail/mail/mail/v1/sync?id=${id}`
  return request.post(url)
}

// 删除邮箱配置
export function delMaliSettingById(ids) {
  const url = `${portal}/mail/mail/mailSetting/v1/remove?ids=${ids}`
  return request.delete(url)
}

// 获取邮件信息列表
export function getMailList(queryFilter) {
  const url = `${portal}/mail/mail/mail/v1/listJson`
  return request.post(url, queryFilter)
}

// 获取邮件详细信息
export function getMailDetail(id) {
  const url = `${portal}/mail/mail/mail/v1/getJson?id=${id}`
  return request.get(url)
}

// 删除邮件
export function delMaliItemById({ ids, type }) {
  const url = `${portal}/mail/mail/mail/v1/remove?ids=${ids}&type=${type}`
  return request.get(url)
}

// 保存邮箱联系人
export function saveContact(data) {
  const url = `${portal}/mail/mail/mailLinkman/v1/save`
  return request.post(url, data)
}

// 保存邮箱联系人列表
export function getContactList(queryFilter) {
  const url = `${portal}/mail/mail/mailLinkman/v1/listJson`
  return request.post(url, queryFilter)
}

// 删除邮箱联系人
export function delContactById(ids) {
  const url = `${portal}/mail/mail/mailLinkman/v1/remove?ids=${ids}`
  return request.delete(url)
}

// 模糊查询联系人和用户信息
export function getMailUserList(query) {
  const url = `${portal}/mail/mail/mailLinkman/v1/getMailAndUserData?query=${query}`
  return request.get(url)
}

// 发送邮件(保存邮件信息)
export function saveOrSendMail(data) {
  const url = `${portal}/mail/mail/mail/v1/send`
  return request.post(url, data)
}

// 设置邮件状态为已读
export function setMailIsRead(id) {
  const url = `${portal}/mail/mail/mail/v1/isRead?id=${id}`
  return request.get(url)
}

/**  邮箱接口 结束 */

//获取我的常用流程
export function getMyOftenFlow(param) {
  const url = `${bpmModel}/bpmMobileCategory/v1/getMyCommonFlow`
  return request.post(url, param)
}

//删除我的常用流程
export function removeOftenFlow(ids) {
  const url = `${bpmModel}/bpmMobileCategory/v1/batchRemove?ids=${ids}`
  return request.delete(url)
}

//保存我的常用流程
export function addOftenFlow(defKyes) {
  const url = `${bpmModel}/bpmMobileCategory/v1/customAddCommonFlow`
  return request.post(url, defKyes)
}

// 常用联系人排序变更
export function swapGroupUser(ids) {
  const url = `${uc}/uc/ucGroupUser/v1/swap`
  return request.post(url, ids)
}

/**
 * date: 2021/11/17
 * @description 内部消息接口
 */
// 获取内部消息
export function getMessageList(queryFilter) {
  const url = `${portal}/innermsg/messageReceiver/v1/list`
  return request.post(url, queryFilter)
}

// 获取未读消息数
export function getMsgBadge() {
  const url = `${portal}/innermsg/messageReceiver/v1/getMsgbadge`
  return request.get(url)
}

// 删除内部消息
export function delInnerMessage(ids) {
  const url = `${portal}/innermsg/messageReceiver/v1/remove?ids=${ids}`
  return request.delete(url)
}

// 标记已读
export function markInnerMessage(ids) {
  const url = `${portal}/innermsg/messageReceiver/v1/mark?ids=${ids}`
  return request.get(url)
}

// 获取内部消息详情
export function getMessageDetail(id) {
  const url = `${portal}/innermsg/messageReceiver/v1/get?id=${id}`
  return request.get(url)
}

/** 内部消息接口 结束 */
